import { QueryFunctionContext } from "@tanstack/react-query";

import { fetchClient } from "checkout-query-client/api/fetch-client";

import { GetMerchantSettingsRequest } from "frontend-client";

type FetchMerchantSettingsQueryKey = Array<{
  scope: "merchant-settings";
  apiHost: string;
  version: string;
  checkoutSessionToken: string;
}>;

export const fetchMerchantSettings = ({
  queryKey: [{ apiHost, version, checkoutSessionToken }],
}: QueryFunctionContext<FetchMerchantSettingsQueryKey>) => {
  const request = new GetMerchantSettingsRequest();
  return fetchClient({ apiHost, version }).getMerchantSettings(request, {
    headers: {
      Authorization: "Bearer " + checkoutSessionToken,
    },
  });
};
